import { render } from "./CodeInputButtons.vue?vue&type=template&id=04bea308&scoped=true"
import script from "./CodeInputButtons.vue?vue&type=script&lang=js"
export * from "./CodeInputButtons.vue?vue&type=script&lang=js"

import "./CodeInputButtons.vue?vue&type=style&index=0&id=04bea308&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04bea308"

export default script